// @flow
import * as React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import {
  withRouter,
  Redirect,
  type Match,
  type Location,
  type RouterHistory,
} from "react-router-dom";
import Gettext from "../../common/Gettext";
import HowMuchInBucks from "../../HowMuchInBucks";
import * as S from "./styles";
import { StyledPopup as Popup } from "./Popup";
import Link from "../Link";
import { FlatButton } from "../../Buttons";
import Tournament from "../Api";
import Spinner from "../../Spinners/SimpleSpinner";
import dataLayer from "../../common/dataLayer";

import { getActive } from "../Timer";

import type { PopupProps } from "./Popup";
import type { Tournament as TournamentProps } from "../../../redux/CommonTypes";
import type { Dispatch } from "../../../redux/action";
import { gaReducer } from "../../GA";
import { Money } from "../../Bell/Item";
import { Link as BasicLink } from "../../common/Link";

const Free = styled.span`
  font-weight: 700;
  text-transform: uppercase;
  color: ${({ theme }) => theme.accent};
`;

const Error = styled.div`
  display: block;
  margin-top: 20px;
  text-align: center;
  font-size: 16px;
  color: tomato;
`;

const FreeLoaderPopup = styled(Popup)`
  @media (min-width: 960px) {
    min-height: 650px;
    width: 740px;
    padding: 0;
  }

  @media (max-width: 959px) {
    align-items: stretch;
    align-content: stretch;
  }
`;

const MobileWrapper = styled(S.MobileWrapper)`
  align-items: stretch;
  align-content: stretch;

  @media (max-width: 959px) {
    justify-content: stretch;
  }
`;

const Wrapper = styled(S.Wrapper)`
  @media (max-width: 959px) {
    min-height: 100%;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background-color: #272b34;

  @media (max-width: 959px) {
    width: 100%;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 33px 0 40px;

  //@media (max-width: 959px) {
  //  padding: 72px 0 35px;
  //}
`;

const ActionsWrapper = styled.div`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  padding: 44px 16px 40px;
  background-color: #181b20;
  flex-grow: 1;

  @media (max-width: 959px) {
    padding: 36px 16px 45px;
    margin-bottom: -80%;
  }
`;

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: stretch;

  //@media (max-width: 959px) {
  //  align-items: center;
  //}
`;

const ActionBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;

  @media (min-width: 960px) {
    flex-grow: 1;
    flex-basis: 0;
  }

  @media (max-width: 959px) {
    width: 100%;
  }
`;

const ActionBoxHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 80px;
  align-items: center;

  @media (max-height: 959px) {
    min-height: 60%;
  }
`;

const ActionBoxTitle = styled.h5`
  font-size: 18px;
  text-align: left;
  color: #ffffff;

  @media (max-width: 959px) {
    text-align: center;
  }
`;

const ActionBoxButton = styled(BasicLink)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 300px;
  min-height: 37px;
  padding: 8px 20px;
  font-size: 12px;
  font-weight: 900;
  color: ${({ color }) => (color ? color : "#ffffff")};
  text-transform: uppercase;
  text-decoration: none;
  background-color: transparent;
  border: 2px solid ${({ color }) => (color ? color : "#ffffff")};
  border-radius: 18px;
  transition: all 0.15s;

  &:hover {
    background-color: ${({ color }) => (color ? color : "#ffffff")};
    color: ${({ hoverColor }) => (hoverColor ? hoverColor : "#0085EB")};
  }

  @media (max-width: 959px) {
    margin-top: 27px;
  }
`;

const ActionBoxInfo = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 31px;

  @media (max-width: 959px) {
    margin-top: 23px;
  }
`;

const ActionBoxInfoText = styled.div`
  display: flex;
  align-items: flex-start;
  text-align: left;
  font-size: 12px;
  line-height: 18px;
`;

// const NewsLink = styled(_NewsLink)`
//   color: #ffcc00;
//   text-decoration: underline;
//   font-size: ${fontSize(12)};
//   text-transform: lowercase;
// `;

const InfoIconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 6px;
`;

const InfoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="currentColor"
    fillRule="evenodd"
  >
    <path
      d="M942.01,299.952a8.055,8.055,0,1,0,8.055,8.055A8.056,8.056,0,0,0,942.01,299.952Zm-1,4.038h2.006v1.975h-2.006V303.99Zm2.978,7.97H940v-1h1v-2.95h-1v-1h3.01v3.953h0.972v1Z"
      transform="translate(-933.016 -299)"
    />
  </svg>
);

const Title = styled.h3`
  width: 510px;
  text-align: center;
  font-size: 28px;
  font-weight: 500;
  line-height: 28px;
  color: #ffffff;

  @media (max-width: 959px) {
    width: 80%;
  }

  @media (max-width: 959px) and (orientation: landscape) {
    margin-top: 5vh;
  }
`;

const Advice = styled.h4`
  width: 312px;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  line-height: 21px;
  color: #ffcc00;
  margin-top: 33px;
`;

const DividerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const DividerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 70%;
  margin: 32px 0 36px;
`;

const Line = styled.div`
  flex-grow: 1;
  border-top: 1px solid;
  height: 1px;
`;

const Word = styled.div`
  font-size: 20px;
  margin: 0 7px;
`;

const Divider = ({ children, style }) => {
  return (
    <DividerContainer>
      <Line />
      <Word>{children}</Word>
      <Line />
    </DividerContainer>
  );
};

type HideProps = { all?: boolean, callback: () => void };

type OrderSensitivePopupProps = {
  in: boolean,
  fetching: boolean,
  onDismiss: (hide: HideProps) => void,
  onClick: () => void,
  fades?: boolean,
  style?: string,
  children: Array<React.Node>,
  invited: boolean,
};

function OrderSensitivePopup({
  in: inProp,
  fetching,
  onDismiss,
  style,
  fades = true,
  onClick,
  children,
  invited,
  error,
}: OrderSensitivePopupProps) {
  const [title, price, ...content] = children;

  return (
    <Popup in={inProp} style={style} fades={fades} onDismiss={onDismiss} nowrap>
      <S.Wrapper nowrap>
        <S.MobileWrapper>
          <S.Title>{title}</S.Title>
          <S.Footer>
            <S.MoneyContainer>{price}</S.MoneyContainer>
            {content && <S.Content>{content}</S.Content>}
            <FlatButton
              type="deposit"
              invited={invited}
              onClick={() => {
                gaReducer("CLICKBTN_JOIN_TOURNAMENT");
                onClick();
              }}
              disabled={fetching}
            >
              {fetching && <Spinner />}
              <Gettext>Join</Gettext>
            </FlatButton>
          </S.Footer>
          {error && <Error>{error}</Error>}
        </S.MobileWrapper>
        <Link to="/conditions">
          <Gettext>Terms & Conditions</Gettext>
        </Link>
      </S.Wrapper>
    </Popup>
  );
}

function FreeloaderShare({ in: inProp, onDismiss, style }) {
  return (
    <FreeLoaderPopup
      in={inProp}
      style={style}
      fades={!!style ? false : true}
      onDismiss={onDismiss}
      big
      full
      stretch
    >
      <Wrapper>
        <MobileWrapper>
          <Header>
            <HeaderWrapper>
              <Title>
                <Gettext>
                  We've limited your access to tournaments at this moment
                </Gettext>
              </Title>
              <Advice>
                <Gettext>
                  This happened because there was no activity on your real
                  account
                </Gettext>
                .&nbsp;
                <Gettext>
                  Please perform one of the following actions to get full access
                </Gettext>
              </Advice>
            </HeaderWrapper>
          </Header>
          <ActionsWrapper>
            <Actions>
              <ActionBox>
                <ActionBoxHeader>
                  <ActionBoxTitle>
                    <Gettext>Top up your trading account.</Gettext>
                  </ActionBoxTitle>
                  <ActionBoxButton
                    onClick={() => {
                      onDismiss({
                        all: true,
                        callback: null,
                      });
                    }}
                    to="/fillup"
                  >
                    <Gettext>Deposit</Gettext>
                  </ActionBoxButton>
                </ActionBoxHeader>
              </ActionBox>
              <DividerWrapper>
                <Divider>
                  <Gettext>Or</Gettext>
                </Divider>
              </DividerWrapper>
              <ActionBox>
                <ActionBoxHeader>
                  <ActionBoxTitle>
                    <Gettext>Share the information about us.</Gettext>
                  </ActionBoxTitle>
                  <ActionBoxButton
                    to="/profile?tab=referral"
                    color="#FFCC00"
                    hoverColor="#181B20"
                    onClick={() => {
                      onDismiss({
                        all: true,
                        callback: null,
                      });
                    }}
                  >
                    <Gettext>Read more</Gettext>
                  </ActionBoxButton>
                </ActionBoxHeader>
              </ActionBox>
              <ActionBoxInfo>
                <InfoIconWrapper>
                  <InfoIcon />
                </InfoIconWrapper>
                <ActionBoxInfoText>
                  <Gettext>
                    Send us a direct link to the post you've made on FB/Twitter
                    or another dedicated website, and we will check it. {""}
                  </Gettext>
                </ActionBoxInfoText>
              </ActionBoxInfo>
            </Actions>
          </ActionsWrapper>
        </MobileWrapper>
      </Wrapper>
    </FreeLoaderPopup>
  );
}

type Props = {
  ...PopupProps,
  ...TournamentProps,
  history: RouterHistory,
  location: Location,
  match: Match,
  style?: string,
  dispatch: Dispatch,
  apiParams?: string,
  dontRedirect: boolean,
  api: {
    fetchEntity: Function,
    readEntity: Function,
  },
  popupCallback?: (status: string) => void,
  onDismissAll?: () => void,
  participation_status: number,
  fromTournamentsList?: boolean,
};

type State = {
  fetching: boolean,
};

class JoinPopup extends React.Component<Props, State> {
  state = {
    fetching: false,
    errorMessage: null,
    freeloader: false,
  };

  joinTournament = async (id: number, apiParams?: string) => {
    const { api, onDismiss, popupCallback, dispatch } = this.props;

    this.setState({ fetching: true, errorMessage: null });

    const join = await api.fetchEntity(
      `/api/tournaments/join?tournament_id=${id}`
    );

    if (join.status === "Resolved") {
      if (join.value && join.value.freeloader) {
        this.setState({ freeloader: true, fetching: false });
        return;
      }

      dataLayer({
        event: "event-to-ga",
        eventCategory: "Tournaments",
        eventAction: "tournament-join",
        eventLabel: `Пользователь вступил в турнир #${id}`,
      });

      const info = await api.fetchEntity(`/api/tournaments/info?id=${id}`);

      if (info.status === "Resolved") {
        if (getActive(info.value) === true) {
          await api.fetchEntity(`/api/tournaments/activate?id=${id}`);
          await api.fetchEntity(`/api/tournaments/stats`);
          dispatch({ type: "ENGAGE_TOURNAMENT_MODE" });
          if (this.props.fromTournamentsList) {
            api.fetchEntity("/api/bell-tolls-items");
            if (typeof apiParams === "string") {
              api.fetchEntity(`/api/tournaments${apiParams}`);
            }
            this.setState({ fetching: false });
            onDismiss({
              all: true,
              callback: null,
            });
            this.props.history.push("/trade");
            return;
          }
        }

        if (this.props.fromTournamentsList) {
          api.fetchEntity("/api/bell-tolls-items");
          if (typeof apiParams === "string") {
            api.fetchEntity(`/api/tournaments${apiParams}`);
          }
          this.setState({ fetching: false });
          onDismiss({
            all: true,
            callback: null,
          });
          this.props.history.push(`/tournaments/${id}`);
          return;
        }

        if (typeof apiParams === "string") {
          api.fetchEntity(`/api/tournaments${apiParams}`);
        } else {
          api.fetchEntity("/api/tournaments/list?status=1");
          api.fetchEntity(
            "/api/tournaments/list?status=1&participation_status=1"
          );
        }

        api.fetchEntity("/api/bell-tolls-items");
        api.fetchEntity("/api/tournaments/stats");

        this.setState({ fetching: false });
        onDismiss({
          all: true,
          callback: popupCallback ? () => popupCallback("success") : null,
        });
        return;
      }
    } else if (join.status === "Rejected") {
      this.setState({ errorMessage: join.message });
    }

    this.setState({ fetching: false });
  };

  componentDidMount() {
    gaReducer("SHOW_TOURNAMENT_JOIN_POPUP");
  }

  render() {
    const {
      in: inProp,
      onDismiss,
      onDismissAll,
      api,
      style,
      dontRedirect,
      apiParams,
      location,
      history,
      match,
      ...tournament
    } = this.props;

    const { id } = tournament;

    if (
      tournament.participation_status === 1 &&
      !dontRedirect &&
      location.pathname !== "/trade"
    ) {
      return <Redirect to="/trade" />;
    }

    if (this.state.freeloader) {
      return <FreeloaderShare in={inProp} onDismiss={onDismiss} />;
    }

    const fades = onDismissAll == null ? true : false;

    const type =
      tournament.subtype === "demo"
        ? "pay"
        : tournament.is_limited && tournament.invited
        ? tournament.pay_account === "demo"
          ? "pay"
          : "free"
        : tournament.type;
    const invited = tournament.is_limited && tournament.invited;
    switch (type) {
      case "free":
        return (
          <OrderSensitivePopup
            invited={invited}
            in={inProp}
            style={style}
            onDismiss={onDismiss}
            fetching={this.state.fetching}
            fades={fades}
            error={this.state.errorMessage}
            onClick={() => this.joinTournament(id, apiParams)}
          >
            <Gettext>
              Participation in the tournament {tournament.title} is
            </Gettext>
            <Free>
              <Gettext>Free</Gettext>
            </Free>
            <Gettext>This tournament is free of charge</Gettext>
          </OrderSensitivePopup>
        );
      case "pay":
        return (
          <OrderSensitivePopup
            invited={invited}
            in={inProp}
            style={style}
            onDismiss={onDismiss}
            fades={fades}
            fetching={this.state.fetching}
            error={this.state.errorMessage}
            onClick={() => this.joinTournament(id, apiParams)}
          >
            <span>
              {tournament.subtype === "demo" ? (
                <Gettext>
                  The following amount will be deducted from your DEMO account
                  for participation in the tournament
                </Gettext>
              ) : (
                <Gettext>
                  The following amount will be deducted from your account for
                  participating in the tournament
                </Gettext>
              )}
              :
            </span>
            {tournament.pay_account === "demo" ||
            tournament.subtype === "demo" ? (
              <React.Fragment>
                <S.MoneyContainer>
                  <Money Value={S.Value} Symbol={S.Currency}>
                    {tournament.participation_price}
                  </Money>
                </S.MoneyContainer>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <HowMuchInBucks
                  value={tournament.participation_price}
                  valueUSD={tournament.participation_price_usd}
                  valueStyle={S.Value}
                  symbolStyle={S.Currency}
                />
              </React.Fragment>
            )}
          </OrderSensitivePopup>
        );
      default:
        return null;
    }
  }
}

export default withRouter(
  connect()((props) => (
    <Tournament.Consumer>
      {(api) => <JoinPopup {...props} api={api} />}
    </Tournament.Consumer>
  ))
);



// WEBPACK FOOTER //
// ./src/components/Tournaments/Popups/Join.js